import { Result, validatedApiCall } from '../api';
import { APIValidationError } from '../../types/api/api';
import { UUID } from '../../types/standard';
import { Voluntario } from '../../types/voluntarios/Voluntario';

export const getVoluntariosBySolicitud = async (
  solicitud_id: UUID,
): Promise<Result<Voluntario[], APIValidationError>> => {
  return validatedApiCall<Voluntario[]>(
    `/api/solicitudes/${solicitud_id}/voluntarios`,
    {
      method: 'GET',
      auth: true,
    },
  );
};
